var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinVectorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6103 3.96938C14.4787 2.02969 12.93 0.960938 11.25 0.960938H6.75C5.07 0.960938 3.52125 2.02969 2.38969 3.96938C1.33219 5.78156 0.75 8.17969 0.75 10.7109C0.75 13.2422 1.33219 15.6403 2.38969 17.4525C3.52125 19.3922 5.07 20.4609 6.75 20.4609H11.25C12.93 20.4609 14.4787 19.3922 15.6103 17.4525C16.6678 15.6403 17.25 13.2422 17.25 10.7109C17.25 8.17969 16.6678 5.78156 15.6103 3.96938ZM15.7303 9.96094H12.7303C12.6717 8.4219 12.3653 6.90239 11.8228 5.46094H14.6906C15.2644 6.71531 15.6431 8.27344 15.7303 9.96094ZM13.7991 3.96094H11.1056C10.7924 3.41748 10.4146 2.91384 9.98063 2.46094H11.25C12.1875 2.46094 13.0688 3.02344 13.7991 3.96094ZM2.25 10.7109C2.25 6.23906 4.3125 2.46094 6.75 2.46094C9.1875 2.46094 11.25 6.23906 11.25 10.7109C11.25 15.1828 9.1875 18.9609 6.75 18.9609C4.3125 18.9609 2.25 15.1828 2.25 10.7109ZM11.25 18.9609H9.98344C10.4174 18.508 10.7952 18.0044 11.1084 17.4609H13.8019C13.0688 18.3984 12.1875 18.9609 11.25 18.9609ZM14.6906 15.9609H11.8237C12.3662 14.5195 12.6727 13 12.7313 11.4609H15.7313C15.6431 13.1484 15.2644 14.7066 14.6906 15.9609Z",
    fill: "#FFFFFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinVectorWhite);
export default __webpack_public_path__ + "static/media/coin-vector-white.e35118eb406bdfa064bc8d370c685120.svg";
export { ForwardRef as ReactComponent };